<template>
  <div>
    <Tabs value="name1" @on-click="tabClick">
      <TabPane label="表单信息" name="name1">
        <form-info ref="FormInfo" :info="info" :suiteArr="suiteArr"></form-info>
      </TabPane>
      <TabPane :label="formDataLabel" name="name2">
        <form-data ref="FormData" :isData="isData" :dbType="info.dbType" @handleTitle="handleTitle"></form-data>
      </TabPane>
      <TabPane label="页面属性" name="name3">
        <form-web ref="FormWeb" :isWeb="isWeb"></form-web>
      </TabPane>
      <Button @click="save()" :loading="saveLoading" type="primary" slot="extra" class="button-right-left">保存</Button>
      <Button @click="back()" slot="extra" class="button-right">返回</Button>
    </Tabs>
  </div>

</template>

<script>
  import FormInfo from './FormInfo';
  import FormData from './FormData';
  import FormWeb from './FormWeb';
  import Util from '@/libs/util.js';

  export default {
    name: 'Form',
    components: {FormWeb, FormData, FormInfo},
    data () {
      return {
        isData:false,
        isWeb:false,
        id: null,
        saveLoading:false,
        suiteArr: [],
        info: {
          id: null,
          tableName: null,
          tableContent: null,
          packageName: null,
          formType: 0,
          formSuite: null,
          dbType: 0,
          keyType: 0,
          persistenceType: 0,
          formFields: []
        },
        keyFlag:false,
        dataArr: [
          {
            fieldName: '',
            content: '',
            length: '',
            pointLength: '',
            defaultValue: '',
            type: '',
            isNull: false,
            isKey: false,
            orderNum: 1,
            isShow: false,
            isShowList: false,
            fieldLength: 320,
            isQuery: false,
            queryMode: null,
            showType: null
          }
        ],
        formDataLabel: h => {
        return h("div", [
          h(
            "span",
            { style: { display: this.keyFlag ? "inline" : "none" } },
            "数据库属性"
          ),
          h("div", { style: { display: this.keyFlag ? "none" : "inline" } }, [
            h(
              "span",
              {
                style: {
                  color: "#ff0000"
                }
              },
              "数据库属性"
            ),
            h(
              "font",
              {
                style: {
                  color: "#ff0000"
                }
              },
              "*"
            )
          ])
        ]);
    }
    };
    },
    mounted () {
      this.listSuite();
      if (typeof (this.$route.query.id) !== 'undefined' && this.$route.query.id !== null && this.$route.query.id !== '') {
        this.id = this.$route.query.id;
        this.initForm();
      }
      console.log()
      if (typeof (this.$route.query.tableName) !== 'undefined' && this.$route.query.tableName !== null && this.$route.query.tableName !== '') {
        this.exportForm(this.$route.query.tableName);
      }
    },
    methods: {
      handleTitle(v) {
        let keyFlag = false;
        let arr = v;
        for (let i = 0; i < arr.length; i++) {
          if (arr[i].fieldName.trim().length === 0) {
            continue;
          }
          // console.log(v);
          if (arr[i].isKey) {
            keyFlag = true;
            break;
          }
        }
        // console.log(1111, keyFlag, v);
        this.keyFlag = keyFlag;
      },
      save () {
        let _this = this;
        this.$refs.FormInfo.$refs['formInfoValidate'].validate((valid) => {
          if (valid) {
            let keyFlag = false;
            let arr=this.$store.state.tabdata.info;
            for (let i = 0; i < arr.length; i++) {
              if(arr[i].fieldName.trim().length === 0){
                continue;

              }else {
                if(arr[i].type==null||arr[i].type==""){
                  _this.$Notice.error({
                    title: '数据属性异常',
                    desc: '数据属性中的字段类型未选择！',
                  });
                  return;
                }
              }
              let isQuery=arr[i].isQuery;
              let isShow=arr[i].isShow;
              if(isQuery){
                if(arr[i].queryMode==null||arr[i].queryMode===""){
                  _this.$Notice.error({
                    title: '页面属性异常',
                    desc: '页面属性勾选了是否查询的字段必须选择查询类型！',
                  });
                  return;
                }
              }
              if(isQuery||isShow){
                if(arr[i].showType==null||arr[i].showType===""){
                  _this.$Notice.error({
                    title: '页面属性异常',
                    desc: '页面属性勾选了是否查询或者表单显示的的字段必须选择控件类型！',
                  });
                  return;
                }
              }

              if(arr[i].type==6||arr[i].type==7||arr[i].type==8){
                if(arr[i].length==null||arr[i].pointLength==null||arr[i].pointLength==""||arr[i].length==""){
                  _this.$Notice.error({
                    title: '数据属性异常',
                    desc: '数据属性字段类型为float、double或者decimal的字段必须填写字段长度和小数点',
                  });
                  return;
                }
              }
              if (arr[i].isKey) {
                keyFlag = true;
              }
              console.log(arr[i].isKey)
            }
            //字段类型中必须有一个字段设置为主键
            if (!keyFlag) {
              _this.$Notice.error({
                title: '数据属性异常',
                desc: '数据属性中的主键未设置！',
              });
              return;
            }
            for (let i = 0; i < arr.length; i++) {
              if(arr[i].fieldName.trim().length === 0){
                arr.splice(i,1);
                continue
              }
              arr[i].isNull = arr[i].isNull ? 1 : 0;
              arr[i].isShow = arr[i].isShow ? 1 : 0;
              arr[i].isShowList = arr[i].isShowList ? 1 : 0;
              arr[i].isQuery = arr[i].isQuery ? 1 : 0;
              arr[i].isKey = arr[i].isKey ? 1 : 0;
            }

            if (_this.info.id === null) {
              _this.create(arr);
            } else {
              _this.put(arr);
            }
          }
        });
      },
      create (arr) {
        let formR = this.info;
        formR.formFields = arr;
        let This = this;
        This.saveLoading=true;
        const [url, httpConfig] = [
          '/api/formTables',
          {
            headers: {
              'Content-Type': 'application/json;charset=UTF-8',
            }
          }
        ]
        This.$http.post(url, formR,httpConfig).then(function (response) {
          This.$Notice.success({
            title: '保存成功'
          });
          This.$router.push({
            name: 'defined-form-list'
          });
        })
          .catch(function (error) {
            This.$Notice.error({
              title: '操作失败！'
            });
            This.saveLoading=false;
          });
      },
      put (arr) {
        let formR = this.info;
        formR.formFields = arr;
        let This = this;
        This.saveLoading=true;
        const [url,httpConfig] = [
          '/api/formTables',
          {
            headers: {
              'Content-Type': 'application/json;charset=UTF-8',
            }
          }
        ]
        This.$http.put(url, formR,httpConfig).then(function (response) {
          This.$Notice.success({
            title: '保存成功'
          });
          This.$router.push({
            name: 'defined-form-list'
          });
        })
          .catch(function (error) {
            This.$Notice.error({
              title: '操作失败！'
            });
            This.saveLoading=false;
          });
      },
      exportForm (name) {
        let This = this;
        const [url,param] = [
          '/api/fields', {
            params: {
              tableName: name
            }
          }
        ]
        This.$http.get(url, param).then(function (response) {
          This.info.tableName = name;
          let formArr = response.data;
          if (formArr.length > 0) {
            This.dataArr = [];
            for (let i = 0; i < formArr.length; i++) {
              let map = {
                fieldName: formArr[i].columnName,
                content: '',
                length: formArr[i].length,
                pointLength: formArr[i].pointLength,
                defaultValue: formArr[i].columnDefault,
                type: formArr[i].dataTypeInt,
                isNull: formArr[i].isNullableInt === 1,
                isKey: formArr[i].isKey === 1,
                orderNum: formArr[i].ordinalPositionInt,
                isShow: false,
                isShowList: false,
                fieldLength: 320,
                isQuery: false,
                queryMode: null,
                showType: null
              };
              This.dataArr.push(map);

              if (map.isKey) {
                This.$refs.FormData.editDisabled = false;
              }

            }
            This.handleTitle(This.dataArr)
            This.$store.commit('setInfo',This.dataArr)
          }

        })
          .catch(function (error) {
            This.$Notice.error({
              title: '操作失败！'
            });
            console.log(error);
          });
      },
      initForm: function () {
        let This = this;
        const url = '/api/formTablesAll/' + This.id;
        This.$http.get(url).then(function (response) {
          This.$refs.FormData.editDisabled = false;
          let form = response.data;
          This.info=form
          This.info.id = form.id;
          This.info.tableName = form.tableName;
          This.info.tableContent = form.tableContent;
          This.info.packageName = form.packageName;
          This.info.formType = form.formType;
          This.info.formSuite = form.formSuite;
          This.info.dbType = form.dbType;


          if (form.formFields.length > 0) {
            for (let i = 0; i < form.formFields.length; i++) {
              form.formFields[i].isNull = form.formFields[i].isNull !== 0;
              form.formFields[i].isShow = form.formFields[i].isShow !== 0;
              form.formFields[i].isShowList = form.formFields[i].isShowList !== 0;
              form.formFields[i].isQuery = form.formFields[i].isQuery !== 0;

              form.formFields[i].isKey = form.formFields[i].isKey !== 0;

            }
            This.dataArr = form.formFields;
          }else{
            This.dataArr = [];
          }
          This.handleTitle(This.dataArr)
          This.$store.commit('setInfo',This.dataArr)

        })
          .catch(function (error) {
            console.log(error);
          });
      },
      listSuite () {
        let This = this;
        const url = '/api/codeTemplateSuitesList' ;
        This.$http.get(url).then(function (response) {
            This.suiteArr = response.data.data;
          })
          .catch(function (error) {
            console.log(error);
          });
      },
      back () {
        this.$router.push({
          name: 'defined-form-list'
        });
      },
      tabClick(v){
        if(v=='name2'){
          this.isData=true
        }
        if(v=='name3'){
          this.isWeb=true
        }
      }
    },


  };
</script>

<style scoped>
  .button-right-left {
    margin-right: 15px;
  }

  .button-right {
    margin-right: 55px;
  }

</style>
